'use strict';

/**
 * Created by cxh on 12/2/2015.
 */
angular.module('betosyswebapp')
  .filter('trustAsResourceUrl', ['$sce', function($sce) {
    return function(val) {
      return $sce.trustAsResourceUrl(val);
    };
  }]);



// WEBPACK FOOTER //
// ./.tmp/components/common/filters/trustAsResourceUrl.js